import { Link } from 'react-router-dom';
import { Card } from '@kawai/ui';

/** S-137: v2（白カード 30/26・枠線なし）。 */
export function NotFoundPage() {
  return (
    <main className="flex min-h-screen items-center justify-center px-4 py-12">
      <Card
        border="none"
        shadow="none"
        padding="none"
        className="w-full max-w-sm rounded-xl px-[30px] py-[26px] text-center"
      >
        <h1 className="text-h-card font-semibold text-ink">404 — Not Found</h1>
        <p className="mt-2 text-body text-ink-2">指定されたページは存在しません。</p>
        <Link
          to="/"
          className="mt-4 inline-block text-body font-medium text-brand-ink underline underline-offset-2"
        >
          テナント一覧に戻る
        </Link>
      </Card>
    </main>
  );
}
